import { VALID_SERVICES } from '$lib/data/services';

// Prerender all service pages
export const prerender = true;

// Generate entries for all lang + service combinations
export function entries() {
	const langs = ['en', 'no'];
	const entries = [];

	for (const lang of langs) {
		for (const service of VALID_SERVICES) {
			entries.push({ lang, service });
		}
	}

	return entries;
}
